import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

interface modal {
  open: boolean;
  handleClose: (event: {}, reason: "backdropClick" | "escapeKeyDown") => void;
  child?: any;
  sx?: object;
}

const CustomModal: React.FC<modal> = ({ open, handleClose, child, sx }) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{ zIndex: 99999 }}
    >
      <Box
        sx={{
          ...sx,
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          borderRadius: 5,
          p: 0,
        }}
      >
        {child}
      </Box>
    </Modal>
  );
};

export default CustomModal;
